import { render } from "./pb-footer.vue?vue&type=template&id=640c2a19"
import script from "./pb-footer.vue?vue&type=script&lang=js"
export * from "./pb-footer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__